import React from "react";
import { OrgProfileInvestoFragment, OrgProfileStartupFragment } from "../fragments/OrgProfileFragment";

export const OrganizationProfileComponent = ({ org }: { org: any }) => {
    return org.type === "startup" ? <OrgProfileStartupFragment org={org} /> : <OrgProfileInvestoFragment org={org} />
}